import { useField } from 'formik';
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
} from '@mui/material';

interface Option {
  readonly value: string;
  readonly label: string;
}

interface FormikRadioGroupProps {
  name: string;
  label: string;
  options: Option[];
  required?: boolean;
  labelRenderer?: (option: Option) => React.ReactNode;
}

export const FormikRadioGroup = ({
  name,
  label,
  options,
  required,
  labelRenderer,
}: FormikRadioGroupProps) => {
  const [field, meta] = useField(name);
  const hasError = meta.touched && !!meta.error;

  return (
    <FormControl error={hasError} required={required}>
      <FormLabel>{label}</FormLabel>
      <RadioGroup {...field} row>
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={<Radio />}
            label={labelRenderer ? labelRenderer(option) : option.label}
          />
        ))}
      </RadioGroup>
      {hasError && <FormHelperText>{meta.error}</FormHelperText>}
    </FormControl>
  );
};
